import React from 'react';
import { render } from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ChakraProvider } from '@chakra-ui/react';
import i18n from './localization/i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore, { history } from './redux/config/configureStore';
import { theme } from './theme';
import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

// redux store
const store = configureStore();

const CssContainer = styled(Box)`
  .chakra-form__required-indicator {
    color: #000000;
  }
`;

// the app
const renderApp = () =>
  render(
    <React.StrictMode>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <ChakraProvider theme={theme}>
            <I18nextProvider i18n={i18n}>
              <CssContainer>
                <App />
              </CssContainer>
            </I18nextProvider>
          </ChakraProvider>
        </ConnectedRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );

// reload only changed
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
